import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import registerImg from "../images/registerimg.jpg";
import { registerUser } from "../api/authApi";

import { FiEye, FiEyeOff } from "react-icons/fi";

const Register = () => {
  const navigate = useNavigate();
const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Validation
  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Full name is required";
    }

    if (!form.email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!form.phone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(form.phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    if (!form.password) {
      newErrors.password = "Password is required";
    } else if (form.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const data = await registerUser(form);

      // Save phone/email for Verify OTP page
      localStorage.setItem("resetPhone", data.phone);
      localStorage.setItem("verifyEmail", data.email);

      // Navigate to OTP verification
      navigate("/verify-otp", { state: { flow: "register" } });
    } catch (err) {
      alert(err.response?.data?.message || "Registration failed");
    }
  };
  return (
    <div className="h-screen grid grid-cols-1 md:grid-cols-2 bg-[#f4ede4]">
      <div className="hidden md:block">
        <img src={registerImg} alt="Register" className="h-full w-full object-cover" />
      </div>

      <div className="flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <h1 className="text-5xl font-semibold mb-6">Create Account</h1>

          <form onSubmit={handleSubmit} className="space-y-6">

            {/* NAME */}
            <div>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
                className={`w-full border-b bg-transparent py-3 focus:outline-none ${
                  errors.name ? "border-red-500" : "border-gray-400"
                }`}
              />
              {errors.name && (
                <p className="text-red-500 text-sm mt-1">{errors.name}</p>
              )}
            </div>

            {/* EMAIL */}
            <div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                className={`w-full border-b bg-transparent py-3 focus:outline-none ${
                  errors.email ? "border-red-500" : "border-gray-400"
                }`}
              />
              {errors.email && (
                <p className="text-red-500 text-sm mt-1">{errors.email}</p>
              )}
            </div>

            {/* PHONE */}
            <div>
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={form.phone}
                onChange={handleChange}
                className={`w-full border-b bg-transparent py-3 focus:outline-none ${
                  errors.phone ? "border-red-500" : "border-gray-400"
                }`}
              />
              {errors.phone && (
                <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
              )}
            </div>

            {/* PASSWORD */}
           <div className="relative">

  <input
    type={showPassword ? "text" : "password"}
    name="password"
    placeholder="Password"
    value={form.password}
    onChange={handleChange}
    className={`w-full border-b bg-transparent py-3 pr-10 focus:outline-none ${
      errors.password ? "border-red-500" : "border-gray-400"
    }`}
  />

  {/* Eye Icon */}
  <div
    className="absolute right-0 top-4 cursor-pointer 
               text-gray-400 hover:text-black transition"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
  </div>

  {/* Error Message */}
  {errors.password && (
    <p className="text-red-500 text-sm mt-1">
      {errors.password}
    </p>
  )}

</div>

            <button className="w-full bg-black text-white py-3 rounded-full mt-4 hover:opacity-90 transition">
              SIGN UP
            </button>

          </form>

          <p className="text-lg mt-6">
            Already have an account?{" "}
            <Link to="/login" className="underline">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
